export const BACKDROP_CONSTANTS = {
  SHOW_BACKDROP: 'SHOW_BACKDROP',
  HIDE_BACKDROP: 'HIDE_BACKDROP',
  HIDE_BACKDROP_IMMEDIATELY: 'HIDE_BACKDROP_IMMEDIATELY',
};

export const BACKDROP_TYPES = {
  PRELOADER: 'PRELOADER',
  SPLASH: 'SPLASH',
  SIMPLE_BACKDROP: 'SIMPLE_BACKDROP',
};
